import React , {useState , useEffect} from "react";
import { renderRoutes } from "react-router-config";
import Layout from "./components/layouts/layouts";
import SimpleForm from "./components/chatbot/SimpleForm";
import { Helmet } from 'react-helmet';

import Loader from "./components/Loader/Loader";
import "./gridLayout.css";
import "./App.css";
import "../src/components/NewHeaderOld/Mobile.css"
import "../src/components/NewHeaderOld/NewDesktopHeader"
import "../src/components/NewHeaderOld/NewHeader.css"
import "../src/components/Redcliffe-Imaging/imagingTop.css";
 
const App = ({ route }) => {
  return (
    <Layout>

      <Helmet>
        {/* <link rel="preconnect" href="http://localhost:3000"/>
        <title>Redcliffe Life Diagnostics: Leading Diagnostic Centre in India</title>
        <meta name="title" content="Redcliffe Life Diagnostics: Leading Diagnostic Centre in India" data-react-helmet="true"/>
        <meta name="description" content="Redcliffe Life Diagnostics is one the best diagnostic centres in India with ICMR and ISO approved Covid Labs on an affordable health checkup packages." />
        <meta name="keywords" content='Diagnostic centres in India' /> */}
      </Helmet>
      <div className="Homeview" id="remove">
        {renderRoutes(route.routes)}
      </div>
     
    </Layout>
  );
};

export default {
  component: App,
};
